export default {
  data: function() {
    return {
      cookiesVisible: true
    }
  },
  created() {
    this.cookiesVisible = !this.$cookie.get("cookies");
  },
  methods: {
    setCookies: function() {
      this.$cookie.set("cookies", true, {expires: "1Y"});
      this.cookiesVisible = false;
    }
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/cookies/script.js